import { render, staticRenderFns } from "./UsedAndUnusedBeds.vue?vue&type=template&id=54459d71&scoped=true&"
import script from "./UsedAndUnusedBeds.vue?vue&type=script&lang=js&"
export * from "./UsedAndUnusedBeds.vue?vue&type=script&lang=js&"
import style0 from "./UsedAndUnusedBeds.vue?vue&type=style&index=0&id=54459d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54459d71",
  null
  
)

export default component.exports